var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, Prop, html } from '@sick-davinci/ce-decorators';
import { style } from './AutoSuggest.style';
import { DropDown } from '../drop-down/DropDown';
export
/**
 * A `davinci-auto-suggest` is a specialization of the 'davinci-drop-down' with auto suggestion.
 * Searches a list for related keywords, phrases and items, which may match the input string.
 *
 * @example
 * ```html
 * <div id="spacing" style="height: 150px">
 *     <davinci-auto-suggest id="custom" label="Tree suggestion" oninput="console.log(event.detail)"
 *         onchange="console.log(event.detail)">
 *         <davinci-option>Maple</davinci-option>
 *         <davinci-option>Beech</davinci-option>
 *         <davinci-option>Pine</davinci-option>
 *         <davinci-option>Birch</davinci-option>
 *         <davinci-option>Spruce</davinci-option>
 *         <davinci-option>Oak</davinci-option>
 *         <davinci-option>Fir</davinci-option>
 *         <davinci-option>Ash</davinci-option>
 *         <davinci-option>Chestnut</davinci-option>
 *     </davinci-auto-suggest>
 * <div>
 * ```
 * @slot { davinci-option[] } `davinci-option` elements to define the dataset for the auto suggest
 * @slot { davinci-option-group[] } `davinci-option-group` elements to define a grouped dataset for the auto suggest
 */
let AutoSuggest = (_dec = Component({
  tag: 'davinci-auto-suggest',
  style,
  inheritStyle: true,
  dependencies: [DropDown]
}), _dec2 = Reflect.metadata("design:paramtypes", []), _dec3 = Prop(), _dec4 = Reflect.metadata("design:type", Number), _dec(_class = _dec2(_class = (_class2 = class AutoSuggest extends DropDown {
  /**
   * Specifies the number of letters, that are needed before the suggestions will be shown.
   */
  constructor() {
    super();

    _initializerDefineProperty(this, "minLength", _descriptor, this);

    _defineProperty(this, "minWidthChecked", false);

    _defineProperty(this, "onBlur", () => {
      super.onBlur();

      if (this.value !== this.valueUnchanged) {
        this.change.emit(this.value);
      }
    });

    _defineProperty(this, "onInputKeyDown", event => {
      if (event.key === 'Enter' && !this._highlightedOption) {
        event.stopPropagation();

        if (this.valueUnchanged !== this.value) {
          this.change.emit(this.value);
        }

        this.value = event.currentTarget.value;
        this.valueUnchanged = this.value;
        this.expanded = false;
      }
    });

    _defineProperty(this, "onInputInput", event => {
      super.onInputInput(event);
      this.expanded = this.value.length >= this.minLength;
      requestAnimationFrame(() => {
        // Update listeners on dynamic options-list. Defer to next render, so the nodelist is up to date.
        this.removeMouseEventListenersFromOptions();
        this.addMouseEventListenersToOptions();
        this.resetSelectedOption();
      });
      this.scheduleRender(true);
    });

    _defineProperty(this, "onClickCapture", event => {
      if (event.target.tagName === 'INPUT') {
        this.expanded = this.value.length >= this.minLength;
      } else {
        this.expanded = this.expanded ? false : this.value.length >= this.minLength;
        this.highlightOption();
      }
    });

    this.editable = true;
    this.contentRenderer = this._renderer;
  }

  onFocus() {
    super.onFocus();
    this.valueUnchanged = this.value;
  }

  selectOption(option) {
    super.selectOption(option);
    this.valueUnchanged = this.value;
  }

  _renderer(value, label) {
    const userInput = this.value;
    const displayVal = label ? label : value;
    let htmlResult;

    if (userInput) {
      htmlResult = this._getFormattedHtml(displayVal, userInput);
    } else {
      htmlResult = html`<span>${displayVal}</span>`;
    }

    return htmlResult;
  }

  _getFormattedHtml(value, userInput) {
    const startIndex = value.toLowerCase().indexOf(userInput.toLowerCase());
    const endIndex = startIndex + userInput.length;

    if (startIndex >= 0) {
      const start = value.substring(0, startIndex);
      const bold = value.substring(startIndex, endIndex);
      const end = value.substring(endIndex, value.length);
      return html`<span>${start}</span><span style="font-weight: bold;">${bold}</span><span>${end}</span>`;
    }

    return null;
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "minLength", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
})), _class2)) || _class) || _class);
